/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageChangeOutSyncResponse
 */
export interface UndercarriageChangeOutSyncResponse {
    /**
     * 
     * @type {number}
     * @memberof UndercarriageChangeOutSyncResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageChangeOutSyncResponse
     */
    undercarriageSideEquipmentId?: number;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageChangeOutSyncResponse
     */
    changeOutDate?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageChangeOutSyncResponse
     */
    machineHoursAtChangeOut?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UndercarriageChangeOutSyncResponse
     */
    isDeleted?: boolean;
}

/**
 * Check if a given object implements the UndercarriageChangeOutSyncResponse interface.
 */
export function instanceOfUndercarriageChangeOutSyncResponse(value: object): value is UndercarriageChangeOutSyncResponse {
    return true;
}

export function UndercarriageChangeOutSyncResponseFromJSON(json: any): UndercarriageChangeOutSyncResponse {
    return UndercarriageChangeOutSyncResponseFromJSONTyped(json, false);
}

export function UndercarriageChangeOutSyncResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageChangeOutSyncResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'undercarriageSideEquipmentId': json['undercarriageSideEquipmentId'] == null ? undefined : json['undercarriageSideEquipmentId'],
        'changeOutDate': json['changeOutDate'] == null ? undefined : json['changeOutDate'],
        'machineHoursAtChangeOut': json['machineHoursAtChangeOut'] == null ? undefined : json['machineHoursAtChangeOut'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
    };
}

export function UndercarriageChangeOutSyncResponseToJSON(json: any): UndercarriageChangeOutSyncResponse {
    return UndercarriageChangeOutSyncResponseToJSONTyped(json, false);
}

export function UndercarriageChangeOutSyncResponseToJSONTyped(value?: UndercarriageChangeOutSyncResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'undercarriageSideEquipmentId': value['undercarriageSideEquipmentId'],
        'changeOutDate': value['changeOutDate'],
        'machineHoursAtChangeOut': value['machineHoursAtChangeOut'],
        'isDeleted': value['isDeleted'],
    };
}

